import { createContext, createRef, useContext } from "react";
export const vortexContext = createContext({
    loadingModel: false,
    updatingCanvas: false,
    preview: undefined,
    vortexCanvasRef: createRef(),
    error: undefined,
});
export const VortexConsumer = vortexContext.Consumer;
export const useVortexContext = () => useContext(vortexContext);
//# sourceMappingURL=vortexContext.js.map